var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });

// src/posthog/config.ts
import { getEnv, getEnvironment } from "@base/environment";
var config = {
  // Required configuration (lazy - see module doc)
  get apiKey() {
    return getEnv("NEXT_PUBLIC_POSTHOG_KEY", { defaultValue: "" });
  },
  get host() {
    return getEnv("NEXT_PUBLIC_POSTHOG_HOST", { defaultValue: "https://eu.i.post\
hog.com" });
  },
  // Debug in development (lazy)
  get debug() {
    return getEnvironment() === "development";
  },
  // Page tracking
  capturePageview: true,
  capturePageleave: true,
  // Session recording
  sessionRecording: {
    enabled: true,
    maskAllInputs: true,
    recordCrossOriginIframes: true,
    recordCanvas: false,
    sampleRate: 1
  },
  // Extended features
  defaults: "2026-01-30",
  autocapture: true,
  enableHeatmaps: true,
  scrollDepth: true,
  // Error tracking (replaces Highlight.io) + dead clicks (replaces Hotjar)
  captureExceptions: true,
  captureDeadClicks: true
};
var serverConfig = {
  get apiKey() {
    return getEnv("NEXT_PUBLIC_POSTHOG_KEY", { defaultValue: "" });
  },
  get host() {
    return getEnv("NEXT_PUBLIC_POSTHOG_HOST", { defaultValue: "https://eu.i.post\
hog.com" });
  },
  flushAt: 1,
  flushInterval: 0
};
function getClientConfig() {
  return {
    apiKey: config.apiKey,
    host: config.host,
    debug: config.debug,
    capturePageview: config.capturePageview,
    capturePageleave: config.capturePageleave,
    sessionRecording: config.sessionRecording
  };
}
__name(getClientConfig, "getClientConfig");
function isPostHogConfigured() {
  return config.apiKey.length > 0 && config.apiKey.startsWith("phc_");
}
__name(isPostHogConfigured, "isPostHogConfigured");
export {
  config,
  getClientConfig,
  isPostHogConfigured,
  serverConfig
};
